var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M953 422L953 450",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 953.5,
    cy: 417.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M953 426L946 422.2V416.2L942 414L953 408L964 414V422H962V415.1L960 416.2V422.2L953 426ZM953 417.7L959.85 414L953 410.3L946.15 414L953 417.7ZM953 423.725L958 421.025V417.25L953 420L948 417.25V421.025L953 423.725Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool2);
export default __webpack_public_path__ + "static/media/school_2.9f5972f3f03f3bf7712b34f40914955f.svg";
export { ForwardRef as ReactComponent };